import { z } from "zod";

/**
 * Regla repetida por los esquemas bilingües del portal (`rewardSchemas.ts`,
 * `offerSchemas.ts`): el campo en español es obligatorio en cuanto hay
 * texto en inglés, porque `isBilingual`/`fieldRejection` del backend lo
 * exige igual (`reward.service.ts`, `offer.service.ts`). Un `superRefine`
 * que llama esta función por cada par de campos evita repetir el mismo
 * bloque de `ctx.addIssue` (jscpd, revisión de duplicación 2026-09-23).
 */
export function requireSpanishWhenEnglishPresent<
  T extends Record<string, unknown>,
>(
  values: T,
  ctx: z.RefinementCtx,
  pairs: ReadonlyArray<{
    esField: keyof T & string;
    enField: keyof T & string;
    message: string;
  }>,
): void {
  for (const { esField, enField, message } of pairs) {
    const esValue = values[esField];
    const enValue = values[enField];
    if (
      typeof enValue === "string" &&
      enValue.trim() &&
      typeof esValue === "string" &&
      !esValue.trim()
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [esField],
        message,
      });
    }
  }
}
